module.exports = __webpack_public_path__ + "static/media/mandated_attack_120.5138bb78.png";